var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyPair = function SvgKeyPair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#key-pair_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.902 5.064a1.136 1.136 0 0 0-.652-1.474M8.607 7.84a3.417 3.417 0 1 0-2.092-3.98c-.058.242-.087.363-.126.432a.5.5 0 0 1-.133.16c-.06.05-.149.09-.324.167L2.167 6.283c-.127.057-.19.085-.245.126a.6.6 0 0 0-.123.129c-.038.055-.063.12-.113.25l-.357.923c-.115.297-.173.446-.159.582a.57.57 0 0 0 .142.322c.092.102.24.16.538.274l1.275.493.41-1.062 1.063.411.41-1.062 1.063.41 1.163-.513c.176-.078.264-.117.342-.128a.5.5 0 0 1 .208.009c.077.018.186.078.405.198q.2.11.418.194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.547 5.101a3.417 3.417 0 0 1-2.649 4.414c-.245.044-.368.066-.439.101a.5.5 0 0 0-.167.124c-.054.058-.098.143-.185.315l-.58 1.132-1.083.35.35 1.083-1.084.35.35 1.084-1.301.42c-.304.098-.455.147-.59.126a.57.57 0 0 1-.314-.16c-.096-.098-.145-.25-.243-.553l-.304-.941c-.043-.133-.064-.2-.07-.266a.6.6 0 0 1 .015-.178c.016-.066.047-.128.11-.252l1.652-3.224"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "key-pair_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgKeyPair;